import logo from "./logo.svg";
import "./App.css";
import ResponsiveAppBar from "./Components/Navbar";
import Professional from "./Components/Professional";
import Projects from "./Components/Projects";
import Drone from "./Components/Drone";
import Skill from "./Components/Skills";
import { About } from "./Components/AboutMe";
import Contact from "./Components/Contact";
import TechStack from "./Components/TechStack";
import Professional2 from "./Components/Professional2";
import Gitinfo from "./Components/Github";
import { Shake, ShakeSlow } from "reshake";
import Typewriter from "typewriter-effect";
import { useEffect } from "react";
//

function App() {
  useEffect(() => {
    document.title = "Tathagat's Portfolio";
    let x = document.querySelector("#favicon");
    console.log(x);
    x.href = "./Tathagat3.jpg";
  }, []);
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <ResponsiveAppBar />
      <div
        className="App"
        style={{
          backgroundColor: "#1b242f",
          width: "100vw",
          position: "relative",
          marginRight: "0",
        }}
      >
        {/* <Professional /> */}
        <Professional2 />
      </div>
      <div
        style={{
          width: "100%",
          fontFamily: "Titillium Web",
          color: "#1b242f",
          fontSize: "3rem",
          display: "inline-block",
          margin: "auto",
          textAlign: "center",
          marginBottom: "2%",
        }}
      >
        <Shake>
          {" "}
          <span
            style={{
              fontFamily: "Ralway",
              fontWeight: "bolder",
              color: "#1b242f",
            }}
          >
            I'm a
          </span>
        </Shake>
        <div style={{ color: "#04c989" }}>
          <Typewriter
            options={{
              strings: [
                "Innovative",
                "Driven",
                "Creative",
                "Frontend Developer",
                "Full Stack Developer",
                "Electrical and Electronics Engineer",
              ],
              autoStart: true,
              loop: true,
              deleteSpeed: 70,
            }}
          />
        </div>
      </div>

      <About />

      <Skill />
      {/* <TechStack /> */}
      <Projects />
      <Gitinfo />
      <Contact />
    </div>
  );
}

export default App;
